{
  "schemaVersion": 1,
  "key": "sarah",
  "name": "Sarah",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/sarah_background.png",
    "calendar": "backgrounds/sarah_background.png",
    "day-of-school": "backgrounds/sarah_background.png",
    "number": "backgrounds/sarah_background.png"
  },
  "mascot": {
    "home": "mascot/sarah_mascot.png"
  },
  "tokens": {
    "accent": "#C33ACF"
  }
}
